import { baseUrlForEnterprise } from "../variables/variables";

 
/*
 * Adapter For API server
 *
 * List Client Master returning promises */
const getEnterprise = async (enterpriseId) => {
  enterpriseId = enterpriseId != undefined ? `/` + enterpriseId : "";
  const settings = {
    method: "GET",
    headers: {
      // Authorization: "Bearer " + Suser.token + "",
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
  try {
    const fetchResponse = await fetch(baseUrlForEnterprise, settings);
    const datahttp = await fetchResponse.json();
    return datahttp;
  } catch (e) {
    return e;
  }
};

/* Delete Client Master returning promises */
const arbitratorDelete = async (id) => {
  const settings = {
    method: "POST",
    headers: {
      Authorization: "Bearer ",
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id: id }),
  };
  try {
    const fetchResponse = await fetch(baseUrlForEnterprise + ``, settings);
    const datahttp = await fetchResponse.json();
    return datahttp;
  } catch (e) {
    return e;
  }
};

/* Add Client Master returning promises */
const EnterpriseAdd = async (data) => {
  const settings = {
    method: "POST", // Use POST for adding data
    headers: {
      Authorization: "Bearer " ,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({...data,'createdBy':localStorage.getItem('userEmail')}), // Send the data in the request body
    mode: "cors",
  };

  try {
    const fetchResponse = await fetch(baseUrlForEnterprise, settings);
    const responseData = await fetchResponse.json();
    console.log(responseData);
    return responseData;
  } catch (e) {
    console.warn(e);
    return e;
  }
};

const EnterpriseEdit = async (id, data) => {
 

  const settings = {
    method: "POST",
    headers: {
      Authorization: "Bearer ",
      Accept: "application/json",
      "Content-Type": "application/json",
    },

    body: JSON.stringify({...data,'createdBy':localStorage.getItem('userEmail')}),
    mode: "cors",
  };
  try {
    const fetchResponse = await fetch(
      `${baseUrlForEnterprise}/${id}`,
      settings
    );
    const data = await fetchResponse.json();

    console.log(fetchResponse);
    return data;
  } catch (e) {
    return e;
  }
};

export { EnterpriseAdd, EnterpriseEdit, getEnterprise };
